import React from 'react';
import PropTypes from 'prop-types';
import { SvgGreen, SvgYellow, SvgRed } from '../svg';


const translations = [
  gettext("Active"),
  gettext("Inactive"),
  gettext("Warning"),
  gettext("Alternative"),
  gettext("Active subscription"),
  gettext("Inactive subscription"),
  gettext("Failing subscription"),
  gettext("Successful transaction"),
  gettext("Unsuccessful transaction"),
  gettext("Refunded transaction"),
  gettext("Pending transaction"),
  gettext("Revoked"),
  gettext("Successful payment"),
  gettext("Unsuccessful payment"),
  gettext("Refunded payment"),
  gettext("Pending payment"),
]


export const StatusPill = ({ state, showText, labels }) => {
  return (
    <span className={`status-pill ${showText ? "show-text" : ""}`}>
      {state === 'active' && <SvgGreen />}
      {state === 'inactive' && <SvgRed />}
      {state === 'warning' && <SvgYellow />}
       {showText && labels[state]}
    </span>
  );
};

StatusPill.propTypes = {
  state: PropTypes.oneOf(['active', 'inactive', 'warning']).isRequired,
  labels: PropTypes.object,
  showText: PropTypes.bool,
};

StatusPill.defaultProps = {
  showText: true,
  state: 'active',
  labels: {
    active: gettext("Active"),
    inactive: gettext("Inactive"),
    warning: gettext("Warning"),
    alternative: gettext("Alternative"),
  }
};


export const SubscriptionStatus = ({ subscription, showText }) => {

  const getSubscriptionState = (subscription) => {
    if (subscription.is_failing) {
      return 'warning';
    }
    if (subscription.active) {
      return 'active';
    }
    return 'inactive';
  }

  const labels = {
    active: gettext("Active subscription"),
    inactive: gettext("Inactive subscription"),
    warning: gettext("Failing subscription"),
  }

  return (
    <StatusPill state={getSubscriptionState(subscription)} showText={showText} labels={labels} />
  )

}

export const TransactionStatus = ({ transaction, showText }) => {

  const getTransactionState = (transaction) => {
    if (transaction.state === 'settled') {
      return 'active';
    }
    else if (transaction.state === 'refunded') {
      return 'alternative';
    }
    else if (transaction.state === 'pending') {
      return 'warning';
    } else {
      return 'inactive'
    }
  }

  const labels = {
    active: gettext("Successful transaction"),
    inactive: gettext("Unsuccessful transaction"),
    alternative: gettext("Refunded transaction"),
    warning: gettext("Pending transaction"),
  }

  return (
    <StatusPill state={getTransactionState(transaction)} showText={showText} labels={labels} />
  )

}

export const ApiKeyStatus = ({ api_key, showText }) => {

  const getApiKeyState = (api_key) => {
    if (api_key.revoked) {
      return 'inactive';
    } else {
      return 'active'
    }
  }

  const labels = {
    active: gettext("Active"),
    inactive: gettext("Revoked"),
    warning: gettext("")
  }

  return (
    <StatusPill state={getApiKeyState(api_key)} showText={showText} labels={labels} />
  )

}



export const PaymentStatus = ({ payment, showText }) => {

  const getPaymentState = (payment) => {
    if (payment.state === 'settled') {
      return 'active';
    }
    else if (payment.state === 'refunded') {
      return 'alternative';
    }
    else if (payment.state === 'pending') {
      return 'warning';
    } else {
      return 'inactive'
    }
  }

  const labels = {
    active: gettext("Successful payment"),
    inactive: gettext("Unsuccessful payment"),
    alternative: gettext("Refunded payment"),
    warning: gettext("Pending payment"),
  }

  return (
    <StatusPill state={getPaymentState(payment)} showText={showText} labels={labels} />
  )

}